// extracted by mini-css-extract-plugin
module.exports = {"relatedBlogs":"RelatedBlogs_relatedBlogs__r0uFt"};